import React from "react";
import AuthLayout from "../AuthLayout/AuthLayout";
import { Button } from "antd";
import * as Yup from "yup";
import { ErrorMessage, Field, Formik, Form as FormikForm } from "formik";
import InputField from "../../components/Input/Inputfeild";
import { useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "./ForgetPassword.css";

const ForgetPassword = () => {
  const initialValues = {
    email: "",
  };

  const history = useHistory();

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Please enter a valid email address")
      .required("Email Address is required"),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    console.log("Form submitted with values:", values);
  };
  return (
    <AuthLayout>
      <div className="signin-container">
        <div className="signin-header">
          <h1>Forgot Password</h1>
          <p>Enter the email address associated with your account and we will send you a code to reset your password</p>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validateOnBlur={false}
        >
          {({ isSubmitting, errors, touched }) => (
            <FormikForm className="login-form">
              <div className="input-wrapper">
                <p>Email Address</p>
                <Field name="email">
                  {({ field }) => (
                    <InputField
                      {...field}
                      placeholder="Email Address"
                      className={`custom-input ${errors.email && touched.email ? "input-error" : ""}`}
                    />
                  )}
                </Field>
                <ErrorMessage name="email" component="div" className="error-message" />
              </div>

              <div className="back-to-signin-container">
                <label className="back-to-signin forget-password " onClick={() => history.push("/login")}>
                  Back to Sign In
                </label>
              </div>

              <Button htmlType="submit" type="primary" className="signin-btn" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : "Send Verification Code"}
              </Button>
            </FormikForm>
          )}
        </Formik>
      </div>
    </AuthLayout>
  );
};

export default ForgetPassword;
